<template>
  <div class="flex items-center space-x-2">
    <button
      @click="decrement"
      :disabled="value <= minValue"
      class="w-8 h-8 rounded-full border-2 border-gray-300 flex items-center justify-center text-gray-600 hover:border-gray-400 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      type="button"
    >
      <Minus class="h-4 w-4" />
    </button>
    
    <input
      type="number"
      :min="minValue"
      :value="value"
      @input="handleInput"
      class="w-16 h-8 text-center border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-mifo-accent focus:border-transparent"
      :class="{ 'bg-gray-50': disabled }"
      :disabled="disabled"
    />
    
    <button
      @click="increment"
      :disabled="disabled"
      class="w-8 h-8 rounded-full border-2 border-gray-300 flex items-center justify-center text-gray-600 hover:border-gray-400 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      type="button"
    >
      <Plus class="h-4 w-4" />
    </button>
  </div>
</template>

<script>
import { computed } from 'vue'
import { Minus, Plus } from 'lucide-vue-next'

export default {
  name: 'QuantitySelector',
  components: { Minus, Plus },
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    minValue: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const value = computed({
      get: () => props.modelValue,
      set: (newValue) => emit('update:modelValue', newValue)
    })

    const increment = () => {
      if (!props.disabled) {
        value.value = value.value + 1
      }
    }

    const decrement = () => {
      if (!props.disabled && value.value > props.minValue) {
        value.value = value.value - 1
      }
    }

    const handleInput = (event) => {
      const newValue = parseInt(event.target.value, 10)
      if (!isNaN(newValue) && newValue >= props.minValue) {
        value.value = newValue
      } else {
        // Reset to minimum value if invalid input
        value.value = props.minValue
      }
    }

    return {
      value,
      increment,
      decrement,
      handleInput
    }
  }
}
</script>
